import { render, staticRenderFns } from "./ReceiptDetail.vue?vue&type=template&id=90cf5242&scoped=true&"
import script from "./ReceiptDetail.vue?vue&type=script&lang=js&"
export * from "./ReceiptDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptDetail.vue?vue&type=style&index=0&id=90cf5242&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "90cf5242",
  null
  
)

export default component.exports